import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Icloud = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.909 5c1.884 0 3.417 1.598 3.417 3.561 0 .136-.012.29-.037.484l-.206 1.594c-.043.332.186.65.528.653l1.65.01c.958.006 1.739.835 1.739 1.848 0 1.02-.785 1.85-1.75 1.85H4.167C2.972 15 2 13.978 2 12.722c0-.913.519-1.735 1.323-2.095l.651-.291c.23-.103.508-.431.516-.775l.016-.714c.012-.535.421-.97.91-.97.032 0 .094.006.207.035l1.039.264c.265.067.606-.066.73-.309l.503-.981C8.493 5.723 9.648 5 10.909 5m0-2C8.828 3 7.023 4.207 6.116 5.974a2.834 2.834 0 00-.699-.096c-1.587 0-2.873 1.304-2.91 2.924A4.28 4.28 0 000 12.722C0 15.085 1.865 17 4.167 17H16.25c2.071 0 3.75-1.724 3.75-3.85 0-2.118-1.667-3.835-3.728-3.848.031-.243.053-.489.053-.741C16.326 5.49 13.901 3 10.909 3z"
  }));
});
Icloud.displayName = 'Icloud';
export var IcloudDimensions = {
  height: 20,
  width: 20
};